import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	dashboards: {
		defaultMessage: 'Dashboards',
		id: 'atlassian-navigation.dashboards.dashboards',
		description: 'Dashboards',
	},
});
